import { useTheme } from "@/components/core/theme";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import MoonIcon from "lucide-solid/icons/moon";
import SunIcon from "lucide-solid/icons/sun";
import { type ComponentProps, splitProps } from "solid-js";

export function ThemeToggle(props: ComponentProps<"button">) {
  const [local, rest] = splitProps(props, ["class"]);

  const { toggle } = useTheme();

  return (
    <Button
      type="button"
      class={cn(
        "relative flex size-7 items-center justify-center rounded-md text-primary hover:bg-transparent focus:outline-none",
        // "*:fill-accent-foreground/70 *:stroke-accent-foreground",
        "*:hover:-rotate-6",
        local.class,
      )}
      size="icon"
      variant="ghost"
      onClick={toggle}
      {...rest}
    >
      <SunIcon class="dark:-rotate-90 h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:scale-0" />
      <MoonIcon class="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span class="sr-only">Toggle theme</span>
    </Button>
  );
}
